import React from "react";

interface AccordionSectionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

interface AccordionContentProps {
  isOpen: boolean;
  children: React.ReactNode;
  isChoiceOptions?: boolean;
}

export const AccordionContent: React.FC<AccordionContentProps> = ({
  isOpen,
  children,
  isChoiceOptions = false,
}) => {
  return (
    <div
      className={`qe-properties-section__content-wrapper ${
        isOpen ? "qe-properties-section__content-wrapper--open" : ""
      } ${
        isChoiceOptions
          ? "qe-properties-section__content-wrapper--choice-options"
          : ""
      }`}
    >
      <div className="qe-properties-section__content">{children}</div>
    </div>
  );
};

export const AccordionSection: React.FC<AccordionSectionProps> = ({
  title,
  isOpen,
  onToggle,
  children,
}) => {
  return (
    <div
      className={`qe-properties-section ${
        isOpen ? "qe-properties-section--active" : ""
      }`}
    >
      <div
        className={`qe-properties-section__title qe-properties-section__title--collapsible ${
          isOpen
            ? "qe-properties-section__title--open"
            : "qe-properties-section__title--closed"
        }`}
        onClick={onToggle}
      >
        <span
          style={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </span>
        <svg
          className={`qe-properties-section__icon ${
            isOpen ? "qe-properties-section__icon--open" : ""
          }`}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <AccordionContent isOpen={isOpen}>{children}</AccordionContent>
    </div>
  );
};
